import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyCYOHmGxXbLYj7yyVlZbf9Z5QoOuPi_BQ4",
    authDomain: "campus-connect-18020.firebaseapp.com",
    projectId: "campus-connect-18020",
    storageBucket: "campus-connect-18020.appspot.com",
    messagingSenderId: "470354449160",
    appId: "1:470354449160:web:d9086082fcc31feb0b52bd",
    measurementId: "G-VDS8CVSLLQ",
};

export const app = initializeApp(firebaseConfig);

// 3. Initialize Analytics (Optional: only runs in browser)
export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;

// 4. Default export the config if you need it elsewhere
export default firebaseConfig;